// extracted by mini-css-extract-plugin
export default {"page":"OO-z","cartModal":"PO-z","checkout":"QO-z","placeholder":"RO-z","account":"SO-z"};